import Phaser from "phaser";
import Canvas from "./libs/react-phaser-fiber/components/Canvas";
import LandingScene from "./scenes/LandingScene";
import MenuScene from "./scenes/MenuScene";
import IntroScene from "./scenes/IntroScene";
import GameScene from "./scenes/GameScene";
import ConnectorScene from "./scenes/ConnectorScene";
import CreditsScene from "./scenes/CreditsScene";
import ConfirmNewGameScene from "./scenes/ConfirmNewGameScene";
import LevelResumeMenu from "./scenes/LevelResumeScene/LevelResumeMenu";
import LevelResumeSceneConfig from "./scenes/LevelResumeScene/config";
import KiStageCompleted from "./scenes/KiStageCompleted/KiStageCompleted";
import KiStageCompletedConfig from "./scenes/KiStageCompleted/config";
import SplashScreenMenu from "./scenes/SplashScreenScene/SplashScreenScene";
import SplashScreenConfig from "./scenes/SplashScreenScene/config";
import CRTFilter from "./utils/CRTShaderFX";
import GrayScalePipeline from "./utils/GrayScalePipeline";
import { setI18nConfig } from "./utils/localization";
import { useEffect, useState } from "react";
import FadePlugin from "phaser3-rex-plugins/plugins/fade-plugin.js";
import FlashPlugin from "phaser3-rex-plugins/plugins/flash-plugin.js";
import CircularProgressPlugin from "phaser3-rex-plugins/plugins/circularprogress-plugin.js";
import TintRGBPlugin from "phaser3-rex-plugins/plugins/tintrgb-plugin.js";
import Scene from "./libs/react-phaser-fiber/components/Scene";
import OptionsScene from "./scenes/GameOptionsScene";
import dbManager from "./utils/dbManager";

const gameConfig = {
  // width: "100vw",
  // height: "100vh",
  width: "100%",
  height: "100%",
  parent: window.document.querySelector("#content"),
  // width: window.innerWidth * window.devicePixelRatio,
  // height: window.innerHeight * window.devicePixelRatio,
  type: Phaser.WEBGL,
  scale: {
    mode: Phaser.Scale.RESIZE,
    // mode: Phaser.Scale.ENVELOP,
    max: {
      width: (window.document.body.clientHeight * 16) / 9,
      height: window.document.body.clientHeight,
    },
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },

  backgroundColor: "#000000",
  disableContextMenu: true,
  pixelArt: true,
  roundPixels: false,
  scene: [
    LandingScene,
    MenuScene,
    IntroScene,
    GameScene,
    ConnectorScene,
    CreditsScene,
    ConfirmNewGameScene,
  ],
  pipeline: { CRTFilter, Gray: GrayScalePipeline, GrayAlt: GrayScalePipeline },
  plugins: {
    global: [
      {
        key: "rexFade",
        plugin: FadePlugin,
        start: false,
      },
      {
        key: "rexFlash",
        plugin: FlashPlugin,
        start: true,
      },
      {
        key: "rexCircularProgressPlugin",
        plugin: CircularProgressPlugin,
        start: true,
      },
      {
        key: "rexTintRGB",
        plugin: TintRGBPlugin,
        start: true,
      },
    ],
  },
};

function updateAspectRatio() {
  const container = document.querySelector("#root");
  const content = document.querySelector("#content");
  const containerRatio = container.clientWidth / container.clientHeight;

  if (containerRatio > 0.56) {
    // If the container is taller than 6/9, set the height and calculate the width
    content.style.width = "100%";
    content.style.height = container.clientWidth / (0.56) + "px";
    // content.style.height = container.clientWidth / (6 / 9) + "px";
  } else {
    // If the container is wider than 6/9, set the width and calculate the height
    content.style.width = container.clientHeight * (0.56) + "px";
    // content.style.width = container.clientHeight * (6 / 9) + "px";
    content.style.height = "100%";
  }
}

function Game() {
  const [ready, setReady] = useState();
  useEffect(() => {
    setI18nConfig(async () => {
      await dbManager.bootUp();
      setReady(true);
    });

    // Update the aspect ratio when the window is resized
    window.addEventListener("resize", updateAspectRatio);

    // Initial setup
    updateAspectRatio();

    return () => {
      window.removeEventListener("resize", updateAspectRatio);
    };
  }, []);
  useEffect(() => {
    if (!ready) return;
    // Update the aspect ratio when the window is resized
    window.addEventListener("resize", updateAspectRatio);

    // Initial setup
    updateAspectRatio();

    return () => {
      window.removeEventListener("resize", updateAspectRatio);
    };
  }, [ready]);

  return ready ? (
    <Canvas args={gameConfig}>
      <Scene name="KiStageCompleted" config={KiStageCompletedConfig}>
        <KiStageCompleted />
      </Scene>
      <Scene name="SplashScreenScene" config={SplashScreenConfig}>
        <SplashScreenMenu />
      </Scene>
      <Scene name="LevelResumeScene" args={LevelResumeSceneConfig}>
        <LevelResumeMenu />
      </Scene>
      <Scene name="OptionsScene" args={LevelResumeSceneConfig}>
        <OptionsScene />
      </Scene>
    </Canvas>
  ) : null;
}

export default Game;
